module.exports = __webpack_public_path__ + "img/marker_one_blue2.b8e12af0.png";